<template>
    <div>
      <b-container>
        <b-row>
          <Map></Map>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import Map from "@/components/Map.vue";
  export default {
    components: {
      Map,
    },
  };
  </script>